import { SmButton, SmLoading } from '@smiles/smiles-react-design-system';
import React from 'react';

type TProps = {
  onClose: () => void;
};

export function ScreenLoading({ onClose }: TProps) {
  return (
    <div className="smls-bank-card-modals__modal-content">
      <div className="smls-bank-card-modals__button--close">
        <SmButton
          onClick={onClose}
          isPill
          isOutlined
          icon={<span className="material-icons">close</span>}
        />
      </div>
      <div className="smls-bank-card-modals__loading" style={{ height: '300px' }}>
        <SmLoading loadingSize="small" />
      </div>
    </div>
  );
}
